import Input from "components/Input";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import SendIcon from "assets/icons/send_purple.svg?react";
import moment from "moment";
import Button from "components/Button";
import CourtPortalService from "api/CourtPortalService";
import { ItemKind } from "dto/IKindItems";
import { useContext } from "react";
import PackagesContext from "contexts/PackagesContext";
import IconsState from "components/IconsState";
import KeysContext from "contexts/KeysContext";
import { useTranslation } from "react-i18next";

const ReceiveModal: FC<Props> = ({ refetch, pack }) => {
  const { t } = useTranslation();
  const { keys } = useContext(KeysContext);
  const { packages, setPackages } = useContext(PackagesContext);
  const signature = pack.Case?.Signature ?? t("common.noSignature");
  const entity = pack.Sender;
  const c = pack.Case?.Title ?? t("cases.noCaseSubject");
  const client = pack.Case?.Client ?? t("cases.noClientSpecified");

  const { mutate: receiveFromCourtPortal, isLoading: isReceiving } =
    CourtPortalService.useReceiveDeliverance();

  const handleClick = () => {
    if (pack.Kind === ItemKind.CourtPortalDeliverance) {
      receiveFromCourtPortal(
        {
          id: pack.Id,
        },
        {
          onSuccess: (result) => {
            if (result?.data) {
              const newPackages = [...packages];
              const toReplace = newPackages.find((x) => x.Id === pack.Id);

              if (toReplace) {
                newPackages[newPackages.indexOf(toReplace)] =
                  result?.data.Object;
                setPackages(newPackages);
              }
            }
            refetch();
          },
        }
      );
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.modal}>
        <div className={styles.content}>
          <div className={styles.title}>{t("packages.parcelData")}</div>
          <div className={styles.date}>
            <div className={styles.left}>
              <SendIcon className={styles.icon} />{" "}
              {moment(pack.SendDate).format("DD.MM.YYYY HH:mm").toString()}
            </div>
            <div className={styles.right}>
              <IconsState
                msg={pack}
                onDownload={null}
                onPreview={null}
                keys={keys}
                showMetricIcon={false}
              ></IconsState>
            </div>
          </div>
          <div className={styles.form}>
            <Input
              disabled
              value={entity}
              label={
                pack?.Kind === ItemKind.CourtPortalDeliverance
                  ? t("packages.leadingAuthority")
                  : t("forms.sender")
              }
              onChange={() => {}}
            />
            {pack?.Kind === ItemKind.CourtPortalDeliverance && (
              <Input
                disabled
                value={signature}
                label={t("packages.caseSignature")}
                onChange={() => {}}
              />
            )}

            {pack?.Kind === ItemKind.CourtPortalDeliverance && (
              <Input
                disabled
                value={c}
                label={t("cases.caseSubject")}
                onChange={() => {}}
              />
            )}
            {pack?.Kind === ItemKind.CourtPortalDeliverance && (
              <Input
                disabled
                value={client}
                label={t("cases.client")}
                onChange={() => {}}
              />
            )}
          </div>
          <div className={styles.buttons}>
            <Button
              className={styles.button}
              text={t("packages.receive")}
              onClick={handleClick}
              loading={isReceiving}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceiveModal;
